// WHERE AN OVERVIEW "REVIEW NOW" BUTTON LANDS. (ZEN-768)
//
// The server builds each button's address (routes/attention.py, review_link);
// this file holds what the pages it opens need to read it, and the words they
// show. Every sentence here is hers and in one place.
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

// `?attention=<warning>` — show only the expenses that warning counted.
export const ATTENTION_PARAM = "attention";

export const ATTENTION_ONLY_CHIP = "Needs your attention only"; // APPROVED by Maryse 2026-10-14

// "Also waiting in 2025 — 1 record." APPROVED by Maryse 2026-10-14
export const alsoWaitingIn = (count) => `— ${count} ${count === 1 ? "record" : "records"}.`;
export const ALSO_WAITING_IN = "Also waiting in";

/** The Overview's own list, for whoever is picked — the same request and the
 *  same cache entry the Overview card reads, so landing costs nothing extra. */
export function useAttention(studentId, { enabled = true } = {}) {
  const url = studentId ? `/attention?student_id=${studentId}` : "/attention";
  return useQuery({
    queryKey: ["attention", studentId || "all"],
    queryFn: async () => (await api.get(url)).data,
    staleTime: 30000,
    enabled,
  });
}

/** The expenses one warning counted, or undefined while unknown. */
export const countedBy = (attention, key) =>
  attention ? (attention.sources || []).find((s) => s.key === key)?.item_ids || [] : undefined;

// The Overview warnings whose Review now opens the Year Alignment section of
// Tax Forms. They count different records, so their years add up. (ZEN-773)
export const TAX_FORMS_WARNINGS = ["year_alignment", "unmatched_withdrawal"];

/** The other tax years where this person's Tax Forms warnings have items,
 *  as [{ year, count }]. */
export function otherYearsWaiting(attention, studentId, year) {
  const byYear = new Map();
  for (const src of attention?.sources || []) {
    if (!TAX_FORMS_WARNINGS.includes(src.key)) continue;
    const row = (src.students || []).find((r) => r.student_id === studentId);
    for (const w of row?.waiting_by_year || []) {
      byYear.set(Number(w.year), (byYear.get(Number(w.year)) || 0) + w.count);
    }
  }
  return [...byYear].filter(([y]) => y !== Number(year)).sort(([a], [b]) => a - b)
    .map(([y, count]) => ({ year: y, count }));
}
